import ClassificationIcon from "../../../../../../components/ClassificationIcon";
import React from "react";
import { ANALYSIS_CLASSIFICATION } from "../../consts";
import { findKey } from "lodash";

const SMA_LIMITS = {
  UNKNOWN: 20,
  SUSPICIOUS: 70
};

const getSmaClassification = (unknownLimit, suspiciousLimit, score) => {
  if (score <= unknownLimit) return ANALYSIS_CLASSIFICATION.UNKNOWN;
  if (score > unknownLimit && score < suspiciousLimit)
    return ANALYSIS_CLASSIFICATION.SUSPICIOUS;
  return ANALYSIS_CLASSIFICATION.MALICIOUS;
};

const CiscoClassificationIcon = data => {
  if (!data.length) return null;

  const smaResultKey = findKey(data, o => o.key === "score");
  const smaErrorKey = findKey(data, o => o.key === "error_info");

  if (smaResultKey) {
    const score = data[smaResultKey]?.value?.toFixed(1);
    const classification = getSmaClassification(
      SMA_LIMITS.UNKNOWN,
      SMA_LIMITS.SUSPICIOUS,
      score
    );
    return (
      <>
        <ClassificationIcon classification={classification} /> {score} / 100.0
      </>
    );
  }

  if (smaErrorKey) return "Analysis failed";

  return null;
};

export default CiscoClassificationIcon;
